import React, { Component } from 'react';

import PropTypes from 'prop-types';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// Material Icons Imports
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIcon from '@material-ui/icons/Assignment';
import School from '@material-ui/icons/School';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

// import ActionSettings from '@material-ui/icons/settings';
import NavigationClose from '@material-ui/icons/Close';

import { Link, Switch, Route, Redirect } from 'react-router-dom';

// Components Imports
// import NewProject from './NewProject';
import NewProjectTMP from './NewProjectTMP';
import ProjectPrint from './ProjectPrint';
import ProjectsList from './ProjectsList';
import UsersList from './UsersList';
import CreateUser from './CreateUser';
import UpdateUser from './UpdateUser';
import UpdateCertification from './UpdateCertification';

// Assets imports
import '../styles/App.css';
import EditProject from './EditProject';
import CreateCertificate from './CreateCertificate';
import CertificatesList from './CertificatesList';
import CreateCertification from './CreateCertification';
import UpdateCertificate from './UpdateCertificate'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: process.env.REACT_APP_PRIMARY_COLOR,
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  paperStyle: {
    // General styles for paper
    width: "auto",
    height: "100%",
    // flex: 1 1 0 %;
    padding: "2em",
    backgroundColor: "rgb(237, 236, 236)",
  },
};

const _handleAccess = (role, path) => {
  return ( role === "Admin" || role === "Office" ) ? true : ( role === "Contracts Manager" && path.includes('projects') ) ? true : false;
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      _handleAccess(localStorage.getItem('current_user_role'), rest.path) ? (
        <Component {...props} />
      ) : (
          <Redirect
            to={{
              pathname: "./users/" + localStorage.getItem('current_user') + '/edit',
              state: { from: props.location }
            }}
          />
        )
    }
  />
);


class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      anchorEl: null
    };
  }


  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  toggleDrawer = (open) => () => {
    this.setState({
      open: open,
    });
  };



  _handleLogOutClick(temp) {
    localStorage.removeItem('token')
    localStorage.removeItem('current_user')
    localStorage.removeItem('current_user_role')
    localStorage.removeItem('current_user_name')
    this.props.history.push("/");
  }

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <AppBar position="static">
            <Toolbar>
              <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.toggleDrawer(true)}>
                <MenuIcon />
              </IconButton>
              <Typography variant="h5" color="inherit" className={classes.grow}>
                Rhodar Site Packs {process.env.REACT_APP_ENV}
              </Typography>

              <div>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : undefined}
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                  color="inherit"
                >
                  <Typography
                   color="inherit"
                  >
                  {localStorage.current_user_name + ', ' + localStorage.current_user_role + '\u00A0' }
                  </Typography>
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={this.handleClose}
                >
                  <MenuItem
                    onClick={this._handleLogOutClick.bind(this)}
                    >
                    <ListItemIcon>
                      <PowerSettingsNewIcon />
                    </ListItemIcon>
                    Sign Out
                  </MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>

          <Drawer open={this.state.open} onClose={this.toggleDrawer(false)}>
            <AppBar position="static">
              <Toolbar>
                <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.toggleDrawer(false)}>
                  <NavigationClose />
                </IconButton>
                <Typography variant="h5" color="inherit" className={classes.grow}>
                  Navigation
            </Typography>
              </Toolbar>
            </AppBar>
            <div
              tabIndex={0}
              role="button"
              onClick={this.toggleDrawer(false)}
              onKeyDown={this.toggleDrawer(false)}
            >
              <div className={classes.list}>
                <List>
                  <ListItemLink to="/projects/list" primary="Projects" icon={<AssignmentIcon />} />
                  <ListItemLink to="/users/list" primary="Users" icon={<PeopleIcon />} />
                  <ListItemLink to="/training/list" primary="Training" icon={<School />} />
                </List>
                <Divider />
              </div>
            </div>
          </Drawer>

          <Paper className={classes.paperStyle} elevation={0} >
            <Switch>
              <PrivateRoute exact path='/projects/pdf/:tab' component={ProjectsList} />
              <PrivateRoute exact path='/projects/list' component={ProjectsList} />
              <PrivateRoute exact path='/projects/new' component={NewProjectTMP} />
              <PrivateRoute exact path='/projects/:id/edit' component={EditProject} />
              <PrivateRoute exact path='/projects/:id/print' component={ProjectPrint} />
              <PrivateRoute exact path='/users/list' component={UsersList} />
              <PrivateRoute exact path='/users/new' component={CreateUser} />
              <PrivateRoute exact path='/training/list' component={CertificatesList} />
              <PrivateRoute exact path='/certificates/new/:user?/:userId?' component={CreateCertificate} />
              <PrivateRoute exact path='/certifications/new' component={CreateCertification} />
              <Route exact path='/users/:id/edit' component={UpdateUser} />
              <PrivateRoute exact path='/certifications/:id/edit' component={UpdateCertification} />
              <Route exact path='/users/certificate/:id/edit' component={UpdateCertificate} />
              <PrivateRoute exact path='/' component={ProjectsList} />
              <Redirect to="/" />
            </Switch>
          </Paper>
        </div>
      </MuiThemeProvider>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

class ListItemLink extends React.Component {
  renderLink = itemProps => <Link to={this.props.to} {...itemProps} />;

  render() {
    const { icon, primary } = this.props;
    return (
      <li>
        <ListItem button component={this.renderLink}>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={primary} />
        </ListItem>
      </li>
    );
  }
}

ListItemLink.propTypes = {
  icon: PropTypes.node.isRequired,
  primary: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};

export default withStyles(styles)(Home);


// WEBPACK FOOTER //
// src/components/App.js